import script from "./HomeEmpireSummary.vue?vue&type=script&setup=true&lang=js"
export * from "./HomeEmpireSummary.vue?vue&type=script&setup=true&lang=js"

import "./HomeEmpireSummary.vue?vue&type=style&index=0&id=0a93fc82&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0a93fc82"]])

export default __exports__